import { SEO } from "@/components/SEO";
import { SparkSessionsHero }   from "../components/site/spark-sessions/SparkSessionsHero";
import { NoProductivityHack }  from "../components/site/spark-sessions/NoProductivityHack";
import { NinetyMinutes }       from "../components/site/spark-sessions/NinetyMinutes";
import { BringItAll }          from "../components/site/spark-sessions/BringItAll";
import { WhyItWorks }          from "../components/site/spark-sessions/WhyItWorks";
import { WhatToExpect }        from "../components/site/spark-sessions/WhatToExpect";
import { MaybeSoundsFamiliar } from "../components/site/spark-sessions/MaybeSoundsFamiliar";
import { SparkSessionsCTA }    from "../components/site/spark-sessions/SparkSessionsCTA";

export default function SparkSessions() {
  return (
    <div data-testid="spark-sessions-page">
      <SEO
        title="Spark Sessions"
        description="One task. Ninety minutes. A focused coaching session with Lara Parrish designed to help you finally start the thing you've been putting off."
        path="/work-with-me/spark-sessions"
      />
      <SparkSessionsHero />
      <NoProductivityHack />
      <NinetyMinutes />
      <BringItAll />
      <WhyItWorks />
      <WhatToExpect />
      <MaybeSoundsFamiliar />
      <SparkSessionsCTA />
    </div>
  );
}
